import React, { Component } from 'react';
import EntitiesRepository from './entities/EntitiesRepository';
import Constants from './constants/Constants';
import GameSequenceHandler from './handlers/GameSequenceHandler';
import ElementsHandler from './handlers/ElementsHandler';
import SoundRepository from './handlers/SoundRepository';
import CardsFactory from './cards/CardsFactory';
import PilesContainer from './entities/piles/PilesContainer'
import ScoreCalculator from './handlers/ScoreCalculator';
import LocalStorage from '../local-storage/LocalStorage';
import PauseButton from '../small-components/pause-button/PauseButton';
import MuteButton from '../small-components/mute-button/MuteButton';
import GameTimer from './handlers/GameTimer';
import setTimeoutTimer from '../tools/setTimeoutTimer'
import './Game.css';
import './Popup.css';

export default class Game extends Component {

    constructor(props) {
        super(props);

        this.gameStatus = Constants.GAME_STATUS_NOT_STARTED;
        this.cards = [];
        this.currentPlayingEntity = null;
        this.cardsContainer = React.createRef();
        this.gameTimerRef = React.createRef();
        this.pauseButtonRef = React.createRef();

        this.idPlayer = LocalStorage.getItem("id");

        this.movingCards = [];
        this.waitForPromises = {};

        this.state = {
            currentPlayingEntity: "",
            elements: []
        };
    }

    componentWillMount() { // TODO: remove componentWillMount
        this.entitiesRepo = new EntitiesRepository(this);
        this.pilesContainer = new PilesContainer(this);
        this.gameSeqHandler = new GameSequenceHandler(this);
        this.elementsHandler = new ElementsHandler(this);
        this.scoreCalculator = new ScoreCalculator(this);
        this.soundRepository = SoundRepository;
        this.pilesContainer.setGeneralDimensions()
        this.resetPositions()
        this.initBoard();
    }

    componentDidMount() {
        this.soundRepository.playBackgroundMusic();
        this.addMuteBtn();
        this.startGame();
        this.addOnPauseAndOnResumeEvents();
        this.addOnResizeEvent();
    }

    componentWillUnmount() {
        for (let key in this.waitForPromises) { // we want to put inside a function, wivh will recive a cb
            this.waitForPromises[key].resolveTimer.pause()
        }

        this.removeEventListeners();
    }

    addMuteBtn = () => {
        const muteButton = <MuteButton />;
        this.elementsHandler.addElement(Constants.ELEMENT_MUTE_BUTTON, muteButton);
    }

    resetPositions = () => {
        this.entitiesRepo.getEntities().forEach(entity => {
            entity.resetInitialCoords()
        })
    }

    removeEventListeners = () => {
        window.removeEventListener("resize", () => { });
        document.removeEventListener("pause", () => { });
        document.removeEventListener("menubutton", () => { });
        document.removeEventListener("resume", () => { });
        document.removeEventListener("deviceready", () => { });
    }

    addOnResizeEvent = () => {
        let pilesContainer = this.pilesContainer
        let entitiesRepo = this.entitiesRepo
        let elementsHandler = this.elementsHandler
        let gameSeq = this.gameSeqHandler
        let newPile = entitiesRepo.getNewPile()
        let index = Constants.ELEMENT_NEW_PILE_PICK_A_CARD
        
        window.addEventListener("resize",() => {
            if (this.gameStatus===Constants.GAME_STATUS_PLAYING || this.gameStatus===Constants.GAME_STATUS_NOT_STARTED){
            entitiesRepo.getEntities().forEach(entity => {
                entity.setScreenDimensions()
            })

            entitiesRepo.getPlayers().forEach(player => {
                player.setInitialCoords()
            })
            pilesContainer.setGeneralDimensions()
            entitiesRepo.getEntities().forEach(entity => {
                entity.resetInitialCoords()
            })
            entitiesRepo.getPlayers().forEach(entity => {
                entity.reArrangeCards()
                entity.removeTitlePlateMarkup()
            })
            entitiesRepo.getPiles().forEach(pile => {
                pile.reArrangePile()
            })
            entitiesRepo.getUsedPile().getCards().forEach(card => {
                card.ref.current.setState({scale: false})
            })

            gameSeq.getCurrentEntity().addPlayerMarkup()
            elementsHandler.getElements().forEach(element => {
                if (element.key === index) {
                    elementsHandler.removeElement(index)
                    gameSeq.getCurrentEntity().addBubbleOnPile("בחר קלף", index, newPile);
                }
            })
        }
        })
    }

    addOnPauseAndOnResumeEvents = () => {
        let getPause = this.pauseButtonRef;
        document.addEventListener("deviceready", () => {
            document.addEventListener("pause", () => getPause.current.pauseGameLogic());
            document.addEventListener("menubutton", () => getPause.current.pauseGameLogic(), false);
            document.addEventListener("resume", () => getPause.current.resumGame());
        });
    }

    stopGame = () => {
        this.pauseButtonRef.current.pauseGame()
    }

    resumeGame = () => {
        this.pauseButtonRef.current.resumGame()
    }

    //TODO: unite with others
    setWaitForEvent = (ms) => {

        if (this.currentPlayingEntity !== null && this.currentPlayingEntity.turnStatus === Constants.TURN_STATUS_END) {
            ms = 0; // prevent waiting
        }

        let id = Math.random().toString(36).substr(2, 9)
        let res, rej;
        let promise = new Promise((resolve, reject) => {
            res = resolve; rej = reject;
        });
        promise.isDone = false;
        promise.resolve = res;
        promise.reject = rej;
        promise.id = id // TODO: WHAT IF TWO PROMISES WILL RECIVE THE SAME ID

        promise.resolveTimer = new setTimeoutTimer(() => { this.resolveWaitForEvent(promise) }, ms)
        this.waitForPromises[id] = promise
        promise.resolveTimer.resume(promise.id);

        return id
    }

    cleanPromiseArray = () => {
        for (let key in this.waitForPromises) {
            if (this.waitForPromises[key].isDone === true) {
                delete this.waitForPromises[key]
            }
        }
    }

    resolveWaitForEvent = (promise) => {
        promise.resolve();
        promise.isDone = true;
        this.cleanPromiseArray()
    }

    initBoard = () => {
        this.cardsFactory = new CardsFactory(this);
        this.cardsFactory.generate();
        this.cards = this.cardsFactory.getCards();
        this.ensureValidDealing();
    }

    waitFor = (ms) => {
        let promiseId = this.setWaitForEvent(ms)
        return this.waitForPromises[promiseId];
    }

    moveCards = async (fromEntityId, toEntityId, cardObjs, arrangeCards = true, waitBetweenCards = true, dinamicRotDeg = true) => {
        this.movingCards = [...cardObjs]
        for (let i = cardObjs.length - 1; i >= 0; i--) {
            let card = cardObjs[i];
            await this.moveCard(fromEntityId, toEntityId, card, arrangeCards, waitBetweenCards, dinamicRotDeg);
        }
    }

    moveCardsSimulation = (fromEntityId, toEntityId, cardObjs) => {
        for (let i = cardObjs.length - 1; i >= 0; i--) {
            let card = cardObjs[i];
            this.moveCardSimulation(fromEntityId, toEntityId, card);
        }
    }

    moveCard = async (fromEntityId, toEntityId, cardObj, arrangeCards = true, waitBetweenCards = true, dinamicRotDeg = true) => {
        if (!cardObj) {
            console.log("NOTE: no cardObj, skipping moveCard");
            return;
        };

        this.soundRepository.playMoveCardSound();

        this.movingCards.push(cardObj);

        let fromEntityObj = this.entitiesRepo.getEntityByIndex(fromEntityId);
        let toEntityObj = this.entitiesRepo.getEntityByIndex(toEntityId);

        toEntityObj.lastReceivedCards.push(cardObj); // Related to exList of attackCards

        if (typeof toEntityObj == "undefined") { console.log("NOTE: No entity for Index (toEntityId)", toEntityId) }

        let [left, top, rotDeg, cardSideShown, layer] = toEntityObj.getCoordsForNewCard(cardObj, dinamicRotDeg);

        toEntityObj.addCard(cardObj);
        fromEntityObj.removeCard(cardObj);

        if (this.gameStatus === Constants.GAME_STATUS_PAUSED) {
            this.pauseButtonRef.current.setPauseEvent();
            await this.pauseButtonRef.current.pauseEvent;
        }

        cardObj.ref.current.changePos(left, top, rotDeg, cardSideShown, toEntityId === Constants.USED_PILE_INDEX, Constants.INTERVAL_CARD_MOVE_FULL / 1000, layer);

        if (arrangeCards) {
            if (typeof fromEntityObj.reArrangeCards !== "undefined") {
                fromEntityObj.reArrangeCards()

            }

            if (typeof toEntityObj.reArrangeCards !== "undefined") {
                if (waitBetweenCards) { await this.waitFor(Constants.INTERVAL_CARD_MOVE_FULL) }
                toEntityObj.reArrangeCards()
            }
        }

        if (fromEntityId === Constants.NEW_PILE_INDEX || fromEntityId === Constants.CANDY_PILE_INDEX) {
            if (fromEntityObj.isPileEmpty()) {
                await fromEntityObj.recycleUsedPile()
            }
        }

        this.removeCardFromMovingCards(cardObj);
    }

    moveCardSimulation = (fromEntityId, toEntityId, cardObj) => {
        if (!cardObj) {
            console.log("NOTE: no cardObj, skipping moveCard");
            return;
        };

        let fromEntityObj = this.entitiesRepo.getEntityByIndex(fromEntityId);
        let toEntityObj = this.entitiesRepo.getEntityByIndex(toEntityId);

        toEntityObj.lastReceivedCards.push(cardObj); // Related to exList of attackCards

        if (typeof toEntityObj == "undefined") { console.log("NOTE: No entity for Index (toEntityId)", toEntityId) }

        toEntityObj.addCard(cardObj);
        fromEntityObj.removeCard(cardObj);
    }

    removeCardFromMovingCards = (cardObj) => {
        for (let i = 0; i < this.movingCards.length; i++) {
            if (this.movingCards[i].ref.current.id === cardObj.ref.current.id) {
                this.movingCards.splice(i, 1);
                break;
            }
        }
    }

    setElements = (elements) => {
        this.setState({ ...elements });
    }

    addInitialElements = () => {
        const gameTimer = <GameTimer gameCtx={this} ref={this.gameTimerRef} />;
        this.elementsHandler.addElement(Constants.ELEMENT_GAME_TIMER, gameTimer);

        const pauseButton = <PauseButton gameCtx={this} ref={this.pauseButtonRef} />;
        this.elementsHandler.addElement(Constants.ELEMENT_PAUSE_BUTTON, pauseButton);

        this.gameSeqHandler.getPlayersSequence().forEach(entity => {
            this.entitiesRepo.getEntityByIndex(entity).removeTitlePlateMarkup()
        })
    }

    startGame = async () => {
        await this.dealCards();
        await this.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        this.addInitialElements();

        this.gameStatus = Constants.GAME_STATUS_PLAYING;
        let entity = null;

        while (this.gameStatus === Constants.GAME_STATUS_PLAYING || this.gameStatus === Constants.GAME_STATUS_PAUSED) {

            entity = this.gameSeqHandler.getCurrentEntity();
            this.setState({ currentPlayingEntity: entity.getName() });
            this.currentPlayingEntity = entity;
            this.currentPlayingEntity.turnStatus = Constants.TURN_STATUS_START;

            this.gameTimerRef.current.startTimer();

            this.gameSeqHandler.getPrevTurnEntity().removePlayerMarkup();
            entity.addPlayerMarkup();

            if (this.isWinning(entity)) { // Checks victory at the begining of the turn
                break;
            }

            await entity.play();

            if (this.isWinning(entity)) { // Checks victory at the end of the turn
                break;
            }

            this.gameSeqHandler.setNextTurn();
        }
    }

    dealCards = async () => {
        let newPile = this.entitiesRepo.getNewPile();
        await newPile.dealCards();
    }

    ensureValidDealing = () => {
        let newPile = this.entitiesRepo.getNewPile();

        // Simulates cards dealing in oreder to check if there is a fair dealing
        newPile.dealCardsSimulation();

        let isNotFair = this.scoreCalculator.isThereAWinner();

        // Undo simulation
        let entities = this.entitiesRepo.getPlayers();

        for (let i = 0; i < entities.length; i++) {
            let entity = entities[i];
            let cards = entity.getCards();
            this.moveCardsSimulation(entity.entityIndex, Constants.NEW_PILE_INDEX, cards); // without changepos
        }

        if (isNotFair) {
            console.log("NOTE: unfair dealing")
            newPile.shuffleDealing();
            this.ensureValidDealing();
            return
        }

        this.cards = this.cardsFactory.getCards();
    }

    isWinning = (entity) => {
        this.scoreCalculator.updateScore(entity);
        let isWinning = this.scoreCalculator.hasFulSet(entity);

        if (isWinning) {
            this.endGame();
            return true;
        }
        return false;
    }

    endGame = () => {
        let cEntity = this.gameSeqHandler.getCurrentEntity();
        this.scoreCalculator.addWinningBonus(cEntity);
        this.scoreCalculator.updateUserScore(this.entitiesRepo.getMyPlayer());
        this.gameStatus = Constants.GAME_STATUS_ENDED;
        this.elementsHandler.removeElement(Constants.ELEMENT_GAME_TIMER);
        this.elementsHandler.removeElement(Constants.ELEMENT_PAUSE_BUTTON);
        this.elementsHandler.removeElement(Constants.ELEMENT_MUTE_BUTTON);
        cEntity.informWinning();
        let enemies = this.gameSeqHandler.getAllCurrentEntityEnemies();
        enemies.forEach(entity => entity.informLosing());
    }

    render() {
        return (
            <div className="game container">
                <div className="cards-container" ref={this.cardsContainer}>
                    {this.cards.map((card) => card.comp)}

                    {this.state.elements.map((e, i) => <span key={i}>{e.elem}</span>)}
                </div>
            </div>
        )
    }
}
